export default __webpack_public_path__ + "static/media/1.fd87c4dc.svg";